'use strict';

if ('customElements' in window) {
  customElements.define('date-range-picker', class extends HTMLElement {
    constructor() {
      super();
      this.filterKey = this.dataset.filterKey;
      this.filterValue = this.dataset.filterValue;
      this.filterLabel = this.dataset.filterLabel;
      this.active = this.dataset.active;
      this.disabled = this.dataset.disabled ? this.dataset.disabled : false;

      if (!this.active) {
        this.datedAtBefore = moment();
        this.datedAtAfter = moment();
        this.filterValue = 'custom';
        this.filterLabel = 'Custom Time';
      } else {
        let queries = [];
        if (this.filterValue !== 'custom') {
          this.filterValue.split('&').forEach(function(queryStr) {
            const queryArr = queryStr.split('=');
            queries[queryArr[0]] = queryArr[1];
          });
          this.datedAtBefore = queries['dated_at_before'] ? queries['dated_at_before'] : moment();
          this.datedAtAfter = queries['dated_at_after'] ? queries['dated_at_after'] : moment();
        }
      }

      this.render();

      const isPc = !$('body').hasClass('sp');

      const $el = $('.custom-picker', this).daterangepicker({
        startDate: this.datedAtBefore,
        endDate: this.datedAtAfter,
        minYear: 2006,
        maxYear: moment().add(1, 'y').year(), // 該当年だと月が選択出来なかったため、+1年を指定(ライブラリのバグ？)
        showCustomRangeLabel: false,
        showDropdowns: true,
        alwaysShowCalendars: true,
        linkedCalendars: isPc,
        applyClass: 'mal-btn',
        cancelClass: 'mal-btn btn-cancel',
        locale: {
          format: 'MMM DD, YYYY',
          cancelLabel: 'Clear'
        },
        opens: 'left',
        ranges: {
          'Past 6 Months': [moment().subtract(6, 'month').startOf('month'), moment()],
          'This year': [
            moment().startOf('year'),
            moment().endOf('year')
          ],
          'Last year': [
            moment().subtract(1, 'years').startOf('year'),
            moment().subtract(1, 'years').endOf('year')
          ],
          'Past 2 years': [
            moment().subtract(2, 'years'),
            moment()
          ],
          'Past 3 years': [
            moment().subtract(3, 'years'),
            moment()
          ],
          'Past 5 years': [
            moment().subtract(5, 'years'),
            moment()
          ],
        },
      });

      this.elem = $el.data('daterangepicker').container;

      $('.custom-picker', this).on('click', function(ev, picker, parentId) {
        if ($(this).hasClass('pressed')) {
          $(this).data('daterangepicker').hide();
        } else {
          $(this).addClass('pressed');
        }
      });

      $('.custom-picker', this).on('hide.daterangepicker', function(ev, picker, parentId) {
        $(this).removeClass('pressed');
      });

      $('.custom-picker', this).on('apply.daterangepicker', function(ev, picker, parentId) {
        parentId = $(this).closest('.filter').attr('id');
        $('.default-label', this).text(picker.startDate.format('MMM DD, YYYY') + ' - ' + picker.endDate.format('MMM DD, YYYY'));
        $(`#${parentId} .custom-picker`).attr('data-dated-at-before', picker.startDate.format('MMM DD, YYYY'));
        $(`#${parentId} .custom-picker`).attr('data-dated-at-after', picker.endDate.format('MMM DD, YYYY'));
        $(`#${parentId} .custom-picker`).attr('data-filter-value', `custom&dated_at_before=${picker.startDate.format('MMM DD, YYYY')}&dated_at_after=${picker.endDate.format('MMM DD, YYYY')}`);
        $(`#${parentId} .custom-picker`).trigger('mal-picker-value');
      });

      $('.custom-picker', this).on('cancel.daterangepicker', function(ev, picker, parentId) {
        parentId = $(this).closest('.filter').attr('id');
        $('.default-label', this).text('Custom Date');
        $(`#${parentId} .custom-picker`).attr('data-dated-at-before', '');
        $(`#${parentId} .custom-picker`).attr('data-dated-at-after', '');
        $(`#${parentId} .custom-picker`).attr('data-filter-label', 'Custom Time');
        $(`#${parentId} .custom-picker`).attr('data-filter-value', 'cancel');
        $(`#${parentId} .custom-picker`).trigger('mal-picker-value');
      });
    }

    render() {
      if ($('#date-range-picker-tmpl').length === 0) {
        throw new DOMException('#date-range-picker-tmplが存在しません。全体に読み込みを行っていないため個別にtwig読み込みをしてください。');
      }
      this.innerHTML = $.templates('#date-range-picker-tmpl').render({
        filterKey: this.filterKey,
        filterValue: this.filterValue,
        filterLabel: this.filterLabel,
        datedAtBefore: this.datedAtBefore,
        datedAtAfter: this.datedAtAfter,
        active: this.active,
        disabled: this.disabled
      });
    }

    /**
     * Runs when the element is removed from the DOM
     */
    disconnectedCallback() {
      this.elem.remove();
    }
  });
}
